export class AdministrativeUnit {
    name = null;
    code = null;
    level = null;
    parent = null;
    children = [];
    linePath = null;
    parentId = null;
    parentName = null;
    parentCode = null;
    province = null;
    district = null;
}